// Product recommendations row. When the element nears the viewport it fetches its inline
// partial (data-partial) from the product recommendations endpoint (data-url with product_id,
// limit and intent), applies it, and reveals itself only when the result has product cards.
import { partials } from '@shopify/partial-rendering';

class ProductRecommendations extends HTMLElement {
  #observer = null;
  #controller = null;

  connectedCallback() {
    if (this.hasAttribute('data-loaded')) return;
    this.#observer = new IntersectionObserver((entries) => {
      if (!entries.some((entry) => entry.isIntersecting)) return;
      this.#observer.disconnect();
      this.#load();
    }, { rootMargin: '0px 0px 600px 0px' });
    this.#observer.observe(this);
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
    this.#controller?.abort();
  }

  async #load() {
    this.#controller = new AbortController();
    const url = new URL(this.dataset.url, window.location.origin);
    url.searchParams.set('product_id', this.dataset.productId);
    url.searchParams.set('limit', this.dataset.limit || '8');
    url.searchParams.set('intent', this.dataset.intent || 'related');

    try {
      // @partial-fetch-contract attributes=data-partial
      const html = await partials.fetch(this.dataset.partial, { url: url.toString(), signal: this.#controller.signal });
      partials.apply(html);
    } catch {
      return;
    }
    this.setAttribute('data-loaded', '');
    this.hidden = !this.querySelector('[data-product-card]');
  }
}

if (!customElements.get('s-product-recommendations')) customElements.define('s-product-recommendations', ProductRecommendations);
